var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._t("title",function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]})],2),_c('p',[_vm._t("sort-description",function(){return [_vm._v(" "+_vm._s(_vm.sortDescription)+" ")]})],2),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }